// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__qU6rj","footer":"ModalCreateQualiphyProcedure_footer__2MaqE","additionData":"ModalCreateQualiphyProcedure_additionData__3Wboe"};